module.exports = __webpack_public_path__ + "static/media/stock-transfer.1821a5f1.svg";